/**
 * Portal Manta · ConclusoesBox
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { V, S, FonteBadge } from '../../globals.js';
import { CONCLUSOES_LOTE } from '../../data/conclusoes-lote.js';

function ConclusoesBox({lote, onFonte}){
  const c = CONCLUSOES_LOTE[lote.k];
  if(!c) return null;
  return (<div style={{...S.cardP, marginBottom:16, padding:'20px 22px', background:'linear-gradient(135deg,#FAF6F1,#fff)', borderLeft:'4px solid '+V.or}}>
    <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:10}}>
      <div style={{width:24,height:24,borderRadius:6,background:V.or,color:'#fff',display:'flex',alignItems:'center',justifyContent:'center',fontSize:14,fontWeight:700}}>★</div>
      <div style={{fontSize:13,fontWeight:700,color:V.br}}>Conclusões — Drivers de Custo Principais</div>
    </div>
    <div style={{display:'flex',flexDirection:'column',gap:12,marginBottom:14}}>
      {c.drivers.map(d=>(<div key={d.n} style={{display:'flex',gap:12,padding:'12px 14px',background:'#fff',borderRadius:8,border:'1px solid '+V.orm}}>
        <div style={{flexShrink:0,width:32,height:32,borderRadius:'50%',background:V.or,color:'#fff',display:'flex',alignItems:'center',justifyContent:'center',fontSize:14,fontWeight:700}}>{d.n}</div>
        <div style={{flex:1}}>
          <div style={{fontSize:12,fontWeight:700,color:V.br,marginBottom:4}}>{d.titulo}</div>
          <div style={{fontSize:11,color:V.g5,lineHeight:1.5,marginBottom:6}}>{d.desc}</div>
          <div style={{display:'inline-block',fontSize:10,fontWeight:700,color:V.or,background:V.orp,padding:'3px 8px',borderRadius:4}}>Impacto: {d.impacto}</div>
        </div>
      </div>))}
    </div>
    <div style={{padding:'12px 14px',background:V.br,color:'rgba(255,255,255,.95)',borderRadius:8,fontSize:11.5,lineHeight:1.6}}>
      <div style={{fontSize:10,fontWeight:700,color:V.or,letterSpacing:.5,textTransform:'uppercase',marginBottom:4}}>Síntese executiva</div>
      {c.sintese}
      <FonteBadge fonte={{doc:'Análise Manta', pag:'Conclusão consolidada do Contexto do Lote', data:'2025-01-01', aut:'Manta · Eng. de Custos'}} onClick={()=>onFonte({fonte:{doc:'Análise Manta', pag:'Conclusão consolidada — fontes: PER, MEF, EVTEA, sondagens DNIT, INMET', data:'2025-01-01', aut:'Manta · Eng. de Custos'},label:'Síntese executiva'})}/>
    </div>
  </div>);
}

export { ConclusoesBox };
export default ConclusoesBox;
